import { API } from "@/lib/api";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export async function downloadCsv(path, filename) {
  const res = await fetch(`${API}${path}`, { credentials: "include" });
  if (!res.ok) throw new Error("Export failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function brandHeader(doc, title) {
  doc.setFillColor(5, 5, 10);
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), 26, "F");
  doc.setTextColor(0, 240, 255);
  doc.setFontSize(14);
  doc.text("SENTINEL / SOC", 14, 12);
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.text(title, 14, 20);
  doc.setTextColor(120, 120, 130);
  doc.setFontSize(8);
  doc.text(new Date().toLocaleString(), doc.internal.pageSize.getWidth() - 14, 20, { align: "right" });
}

export function exportThreatsPdf(threats) {
  const doc = new jsPDF();
  brandHeader(doc, "Threat Intelligence Report");
  autoTable(doc, {
    startY: 32,
    head: [["Detected", "Severity", "Title", "Category", "Status", "Source IP", "Target"]],
    body: threats.map((t) => [
      new Date(t.detected_at).toLocaleString(),
      (t.severity || "").toUpperCase(),
      t.title, t.category, t.status, t.source_ip, t.target,
    ]),
    styles: { font: "courier", fontSize: 7, cellPadding: 2 },
    headStyles: { fillColor: [18, 18, 30], textColor: [0, 240, 255] },
    alternateRowStyles: { fillColor: [245, 245, 248] },
  });
  doc.save("threat-report.pdf");
}

export function exportIncidentsPdf(incidents) {
  const doc = new jsPDF();
  brandHeader(doc, "Incident Report");
  autoTable(doc, {
    startY: 32,
    head: [["Created", "Severity", "Status", "Title", "Assignee"]],
    body: incidents.map((i) => [
      new Date(i.created_at).toLocaleString(),
      (i.severity || "").toUpperCase(),
      i.status, i.title, i.assignee,
    ]),
    styles: { font: "courier", fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [18, 18, 30], textColor: [0, 240, 255] },
    alternateRowStyles: { fillColor: [245, 245, 248] },
  });
  doc.save("incident-report.pdf");
}
